// noinspection JSUnresolvedReference,JSClosureCompilerSyntax

/*
 * Copyright (c) 2025-present TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 */

import { brazeSetUserEmail, brazeSubscribeBackInStock } from '@theme/braze';
import { AbstractBrazeForm } from '@theme/abstract-braze-form';

/**
 * @typedef {Object} Refs
 * @property {HTMLInputElement} quantityInput
 * @extends {AbstractBrazeForm<Refs>}
 */
class BackInStockForm extends AbstractBrazeForm {
  /**
   * Get email field
   *
   * @returns {Element}
   */
  getEmailField() {
    return this.querySelector('[type="email"]');
  }

  /**
   * Get email value
   *
   * @returns {string}
   */
  getEmailAddress() {
    return this.getEmailField()?.value || '';
  }

  /**
   * Check if email is valid
   *
   * @returns {boolean}
   */
  isEmailValid() {
    return this.getEmailAddress() &&
      this.getEmailField()?.validity?.valid;
  }

  /**
   * Inline submit handler
   */
  _handleSubmit() {
    // check email validity and update braze user info
    if (!this.isEmailValid() ||
      !brazeSetUserEmail(this.getEmailAddress())) {
      this.setError(this.dataset.messageErrorInvalidEmail);
      return;
    }

    // subscribe
    if (brazeSubscribeBackInStock(this.dataset.productId)) {
      this.setSuccess();
    } else {
      this.setError(this.dataset.messageErrorNotSaved);
    }
  }
}

if (!customElements.get('back-in-stock-form')) {
  customElements.define('back-in-stock-form', BackInStockForm);
}
